<main>
    <div class="container-fluid fondo-cabecera-page py-5" style="background: url(../../../../assets/img/imagen-home.jpg) center bottom;">
        <div class="container">
            <div class="row fade-in-fwd">
                <div class="col-12">
                    <div class="row pt-2 pb-1">
                        <div class="col-12 text-center mx-auto login-cabecera px-0">
                            <img src="../../../../assets/img/gn-logo.svg">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12 col-lg-4 mx-auto px-3">
                    <div class="row">
                        <div class="col-12 card shadow-sm px-2 py-3">
                            <div class="row">
                                <div class="col-12 col-md-11 mx-auto text-center">
                                    <h4 class="fw-bold">
                                        Página no encontrada
                                    </h4>
                                    <p>La página que buscas no existe, por favor verifica que la dirección sea correcta o reinténtalo más tarde...</p>
                                </div>
                                <div class="col-12 mb-2 text-center" style="margin-top:0px;" >
                                    <img src="../assets/img/error.gif" style="width: 250px;">
                                </div>
                                <a  style="margin-top:-30px;" class="btn btn-primary col-10 col-md-4 mx-auto mb-2 text-center">
                                    <img src="../assets/img/flecha-blanca-izquierda.svg" style="float:left;padding-top:5px;">Volver
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>